import { makeRequest } from '../../../lib/api';

const REF_PATH = '/v1/ref';
const REF_VALUE_PATH = '/v1/ref_value';
const SUBJECT_OF_THE_RUSSIAN_FEDERATION = '/v1/regions';

class universalReferenceController {
  getRef = (data = {}, callback) => {
    return makeRequest('get', `${ REF_PATH }`, data, callback);
  };

  createRef = (data = {}, callback) => {
    return makeRequest('post', `${ REF_PATH }`, data, callback);
  };

  deleteRef = (data = {}, callback) => {
    return makeRequest('delete', `${ REF_PATH }/${ data.id }`, data, callback);
  };

  updateRef = (data = {}, callback) => {
    return makeRequest('put', `${ REF_PATH }/${ data.id }`, data, callback);
  };

  getRefValue = (data = {}, callback) => {
    return makeRequest('get', `${ REF_VALUE_PATH }/${ data.refId }`, data, callback);
  };

  createRefValue = (data = {}, callback) => {
    return makeRequest('post', `${ REF_VALUE_PATH }`, data, callback);
  };

  deleteRefValue = (data = {}, callback) => {
    return makeRequest('delete', `${ REF_VALUE_PATH }/${ data.id }`, data, callback);
  };

  updateRefValue = (data = {}, callback) => {
    return makeRequest('put', `${ REF_VALUE_PATH }/${ data.id }`, data, callback);
  };

  // субъекты РФ
  getSubjectRF = () => {
    return makeRequest('get', `${ SUBJECT_OF_THE_RUSSIAN_FEDERATION }`);
  };
}

export default new universalReferenceController();
